export default __webpack_public_path__ + "42b966ac8320cf6d5a3401c8906c7b43.png";